<div class="d-flex flex-row justify-content-between">
    <svg-icon *ngIf="getEmployeeId.employeeName && getEmployeeId.employeeId" class="cursor-pointer" src="../assets/images/icons/general/arrow.svg" (click)="backEmitButton()"></svg-icon>
    <app-fusion-button buttonType="primary" buttonValue="+ Add Record" (buttonClickEmit)="formDeclaration(); this.addNewRecord = true; this.editRecord = false" [buttonDisable]="addNewRecord ||  editRecord"></app-fusion-button>
</div>
<!-- SK15JUL24 displaying employee Id and Name -->
<div *ngIf="getEmployeeId.employeeName && getEmployeeId.employeeId">{{getEmployeeId.employeeName + "[" + getEmployeeId.employeeId + "]"}}</div>

<div class="comp-container p-4  mt-4" *ngIf="addNewRecord">
    <form [formGroup]="compensationForm" >
        <div class="d-flex flex-row">
            <div class="w-75 d-flex">
                <div class="d-flex row justify-content-start">
                    <div class="col-4 input-margin-top">
                        <label class="form-label label-txt">Annual CTC</label>
                        <div class="field-input">
                            <input class="form-control" type="number" placeholder="" formControlName="annualCTC" (keyup)="ctcFunction()">
                        </div>
                    </div>
                    <div class="col-4 input-margin-top">
                        <label class="form-label label-txt">Gross Salary / Annum</label>
                        <div class="field-input">
                            <input class="form-control" type="number" placeholder="" formControlName="grossPay" [readOnly]="true">
                        </div>
                    </div>
                    <!-- SK15JUL24 adding variable pay input -->
                    <div class="col-4 input-margin-top">
                        <label class="form-label label-txt">Variable Pay / Annum</label>
                        <div class="field-input">
                            <input class="form-control" type="number" placeholder="" formControlName="variablePayYearly" [readOnly]="true">
                        </div>
                    </div>
                    <div class="col-3 input-margin-top">
                        <label class="form-label label-txt">Net Salary / Annum</label>
                        <div class="field-input">
                            <input class="form-control" type="number" placeholder="" formControlName="netPay" [readOnly]="true">
                        </div>
                    </div>
                    <div class="col-3 input-margin-top">
                        <!-- SK18JUN24 net pay per month-->
                        <label class="form-label label-txt">Take Home Salary / Month</label>
                        <div class="field-input">
                            <input class="form-control" type="number" placeholder="" formControlName="netPayMonthly" [readOnly]="true">
                        </div>
                    </div>
                    <div class="col-3 input-margin-top">
                        <label class="form-label label-txt">Effective date</label>
                        <div class="field-input">
                            <input class="form-control" type="date" placeholder="" formControlName="effectiveDate" (change)="calculateTotal()">
                        </div>
                    </div>
                    <!-- SK18JUN24 balance amount to tally the compensation -->
                    <div class="col-3 input-margin-top text-end">
                        <label class="form-label label-txt">Balance Amount To Tally</label>
                        <div class=" text-end"> {{balanceToTally}}
                        </div>
                    </div>
                    <!-- SK25JUL24 adding currency code in compensation -->
                    <div class="col-3 input-margin-top">
                        <label class="form-label label-txt">Currency Code</label>
                        <app-drop-down  [lists]='currencyDropdown'
                        dropBorderRadius="5px 5px 5px 5px"
                        (dataEmit)="emittedValue($event, 'currencyCode')"
                        [selectedData]="currencyValue"></app-drop-down>
                    </div>
                </div>
            </div>
            <div class="w-25  d-flex justify-content-center">
                <app-fusion-button buttonValue="Cancel" buttonType="text-only" (buttonClickEmit)="addNewRecord = false; editRecord = false"></app-fusion-button>
                <app-fusion-button buttonValue="Save" [buttonDisable]="compensationForm.invalid" (buttonClickEmit)="saveCompensation()"></app-fusion-button>
            </div>
        </div>

        <table>
            <thead>
                <th class="ps-4">Salary Components</th>
                <th class="ps-4">Calculation Type</th>
                <th class="text-end pe-4">Amount Monthly</th>
                <th class="text-end pe-4">Amount Yearly</th>
            </thead>
        
            <tbody *ngFor="let item of result; let i=index">
                <td class="comp-background">{{ item.type }}</td>
                <td class="comp-background"></td>
                <td class="comp-background"></td>
                <td class="comp-background"></td>
                <!-- Salary components-->
                <tr *ngFor="let value of item.components; let j=index">
                    <td >{{ value.componentName }}</td>

                    <!-- Calculation type-->
                    <td *ngIf="value.calculationBasis === 'flat' ">
                        System Calculated
                    </td>
                    <td class="flex flex-row" *ngIf="value.calculationBasis === 'percentage' ">
                        <input class="form-control tabe-input text-end radius-none" type="number" [value]="value.percentRate" (keyup)="calculatePercentAmount(i, $event, j)">
                        <div class="align-self-center ms-2">% of Basic</div>
                    </td>
                    <td class="flex flex-row"  *ngIf="value.calculationBasis === 'fixed' ">
                        <input class="form-control tabe-input text-end radius-none" type="number" [value]="value.percentRate" (keyup)="calculatePercentAmount(i, $event, j)">
                        <div class="align-self-center ms-2">% of Gross</div>
                    </td>

                    <!-- Amount monthly-->
                    <td >
                        <input class="form-control tabe-input text-end radius-none margin-65" type="number" [value]="value.amountMonthly" [readonly]="true">
                    </td>

                    <!-- Amount yearly-->
                    <td >
                        <input class="form-control tabe-input text-end radius-none margin-65" type="number" [value]="value.amountYearly"  (keyup)="value.calculationBasis === 'fixed' || value.calculationBasis === 'percentage' ? calculateFixedPercentAmount(i, $event, j) : calculateFixedAmount(i, $event, j)">
                    </td>
                </tr>
            </tbody>
            <tr class="comp-background">
                <td class="">Cost To Company</td>
                <td></td>
                <td class="text-end  pe-4">{{compensationForm.controls['totalCalculatedMonthly'].value}}</td>
                <td class="text-end  pe-4">{{compensationForm.controls['totalCalculatedYearly'].value}}</td>
            </tr>
            <!-- SK18JUN24 total deductions and netpay  -->
            <tr class="comp-background">
                <td class="">Total Deductions(Deductions + Benefits)</td>
                <td></td>
                <td class="text-end  pe-4">{{compensationForm.controls['totalDeductionsMonthly'].value}}</td>
                <td class="text-end  pe-4">{{compensationForm.controls['totalDeductionsYearly'].value}}</td>
            </tr>
            <tr class="comp-background">
                <td class="">Net Pay</td>
                <td></td>
                <td class="text-end  pe-4">{{compensationForm.controls['totalNetPayMonthly'].value}}</td>
                <td class="text-end  pe-4">{{compensationForm.controls['totalNetPayYearly'].value}}</td>
            </tr>
        </table>
        <div class="comp-background mt-4 ps-4 pt-4 pb-4">Over Time Calculation</div>
        <div class="flex flex-row ps-4 pe-4 mt-4 justify-content-between">
            <div class="w-50"> Calculation type to be included with Basic Pay </div>
            <div class="w-50 text-end">
                <label *ngFor="let allowance of allowanceList" class="cursor-pointer ms-3">
                    <input type="radio" name="overTimeCalculationComps" formControlName="overTimeCalculationComps" [value]="allowance.componentName" (change)="overTimeAmount()" /> 
                    {{ allowance.componentName }}
                </label>
            </div>
        </div>
        <div class="flex flex-row ps-4 pe-4 mt-3 justify-content-between">
            <div class="w-50">Number of regular working days in a month</div>
            <div class="w-50">
                <input class="form-control tabe-input text-end radius-none margin-65" type="number" formControlName="overTimeCalcDays" (keyup)="calculateOT($event, 'overTimeCalcDays')">
            </div>
        </div>
        <div class="flex flex-row ps-4 pe-4 mt-3 justify-content-between">
            <div class="w-50">Number of regular working hours for this employee</div>
            <div class="w-50">
                <input class="form-control tabe-input text-end radius-none margin-65" type="number"  formControlName="overTimeCalcHours" (keyup)="calculateOT($event, 'overTimeCalcHours')">
            </div>
        </div>
        <div class="flex flex-row ps-4 pe-4 mt-3 justify-content-between">
            <div class="w-50">Calculated OT amount/hour</div>
            <div class="w-50">
                <input class="form-control tabe-input text-end radius-none margin-65" type="number"  formControlName="overTimeCalcAmount" (keyup)="calculateOT($event, 'overTimeCalcAmount')">
            </div>
        </div>
        <div class="w-100 mt-3  d-flex justify-content-end">
            <app-fusion-button buttonValue="Cancel" buttonType="text-only" (buttonClickEmit)="addNewRecord = false; editRecord = false"></app-fusion-button>
            <app-fusion-button buttonValue="Save" [buttonDisable]="compensationForm.invalid" (buttonClickEmit)="saveCompensation()"></app-fusion-button>
        </div>
    </form>
</div>

<div *ngFor="let comp of compInfo; let i=index"  >
    <div #openAccordion  class="comp-container p-4  mt-4">
        <div class="d-flex flex-row justify-content-between">
            <div #arrow class="d-flex flex-row">
                <img class="edit-open" src="../assets/images/icons/general/arrow-dropdown.svg"  (click)="toggleForm(i,comp);">
                <div class="ms-2 align-self-center">{{comp.compensationId}}</div>
            </div>
            <div class="d-flex flex-row">
                <img *ngIf="!editRecord" class="me-2 cursor-pointer" src="../assets/images/icons/Vectorpencil.svg" (click)="editComp(comp); toggleHelper(i); editRecord = true;">
                <mat-checkbox *ngIf="!editRecord"  #checkComp class="me-2" (click)="$event.stopPropagation()" id="compId{{i}}"
                    (change)="$event ? activateCompensation($event, comp, i) : null"
                    [checked]="activateCompSelection.isSelected(comp)"  [disabled]="comp.activeCheckbox"  [matTooltip]="comp.activeCheckbox === true ? 'Please complete the process to activate this compensation' : '' ">
                </mat-checkbox>
                <div *ngIf="!editRecord" class="w-100 me-2">In use</div>
            </div>
        </div>
    </div>
    <div class="comp-container mt-4 accordion-content">
        <form class="p-4" [formGroup]="compensationForm" >
            <div class="d-flex flex-row">
                <div class="w-75 d-flex">
                    <div class="d-flex row justify-content-start">
                        <div class="col-4 input-margin-top">
                            <label class="form-label label-txt">Annual CTC</label>
                            <div class="field-input">
                                <input class="form-control" type="number" placeholder="" formControlName="annualCTC" (keyup)="ctcFunction()">
                            </div>
                        </div>
                        <div class="col-4 input-margin-top">
                            <label class="form-label label-txt">Gross Salary / Annum</label>
                            <div class="field-input">
                                <input class="form-control" type="number" placeholder="" formControlName="grossPay" [readOnly]="true">
                            </div>
                        </div>
                        <div class="col-4 input-margin-top">
                            <!-- SK15JUL24 -->
                            <label class="form-label label-txt">Variable Pay / Annum</label>
                            <div class="field-input">
                                <input class="form-control" type="number" placeholder="" formControlName="variablePayYearly" [readOnly]="true">
                            </div>
                        </div>
                        <div class="col-3 input-margin-top">
                            <label class="form-label label-txt">Net Salary / Annum</label>
                            <div class="field-input">
                                <input class="form-control" type="number" placeholder="" formControlName="netPay" [readOnly]="true">
                            </div>
                        </div>
                        <div class="col-3 input-margin-top">
                            <!-- SK18JUN24 net salary per month -->
                            <label class="form-label label-txt">Take Home Salary / Month</label>
                            <div class="field-input">
                                <input class="form-control" type="number" placeholder="" formControlName="netPayMonthly" [readOnly]="true">
                            </div>
                        </div>
                        <div class="col-3 input-margin-top">
                            <label class="form-label label-txt">Effective date</label>
                            <div class="field-input">
                                <input class="form-control" type="date" placeholder="" formControlName="effectiveDate" (change)="calculateTotal()">
                            </div>
                        </div>
                        <!-- SK18JUN24 balance amount to be tallied for compensation-->
                        <div class="col-3 input-margin-top text-end">
                            <label class="form-label label-txt">Balance Amount To Tally</label>
                            <div class=" text-end"> {{balanceToTally}}
                            </div>
                        </div>
                        <!-- SK25JUL24 adding currency code -->
                        <div class="col-3 input-margin-top">
                            <label class="form-label label-txt">Currency Code</label>
                            <app-drop-down  [lists]='currencyDropdown'
                            dropBorderRadius="5px 5px 5px 5px"
                            (dataEmit)="emittedValue($event, 'currencyCode')"
                            [selectedData]="currencyValue"></app-drop-down>
                        </div>
                    </div>
                </div>
                <!-- ngif is used to display the buttons only in edit mode -->
                <div *ngIf="isViewOn" class="w-25  d-flex justify-content-center">
                    <app-fusion-button buttonValue="Cancel" buttonType="text-only" (buttonClickEmit)="addNewRecord = false; editRecord = false; cancelAccordion(i)"></app-fusion-button>
                    <app-fusion-button buttonValue="Save" [buttonDisable]="compensationForm.invalid" (buttonClickEmit)="saveCompensation()"></app-fusion-button>
                </div>
            </div>
            <table>
                <thead>
                    <th class="ps-4">Salary Components</th>
                    <th class="ps-4">Calculation Type</th>
                    <th class="text-end pe-4">Amount Monthly</th>
                    <th class="text-end pe-4">Amount Yearly</th>
                </thead>
            
                <tbody *ngFor="let item of result; let i=index">
                    <td class="comp-background">{{ item.type }}</td>
                    <td class="comp-background"></td>
                    <td class="comp-background"></td>
                    <td class="comp-background"></td>
                    <!-- Salary components-->
                    <tr *ngFor="let value of item.components; let j=index">
                        <td >{{ value.componentName }}</td>
    
                        <!-- Calculation type-->
                        <td *ngIf="value.calculationBasis === 'flat' ">
                            System Calculated
                        </td>
                        <td class="flex flex-row" *ngIf="value.calculationBasis === 'percentage' ">
                            <input class="form-control tabe-input text-end radius-none" type="number" [value]="value.percentRate" (keyup)="calculatePercentAmount(i, $event, j)">
                            <div class="align-self-center ms-2">% of Basic</div>
                        </td>
                        <td class="flex flex-row"  *ngIf="value.calculationBasis === 'fixed' ">
                            <input class="form-control tabe-input text-end radius-none" type="number" [value]="value.percentRate" (keyup)="calculatePercentAmount(i, $event, j)">
                            <div class="align-self-center ms-2">% of Gross</div>
                        </td>
    
                        <!-- Amount monthly-->
                        <td >
                            <input class="form-control tabe-input text-end radius-none margin-65" type="number" [value]="value.amountMonthly" [readonly]="true">
                        </td>
    
                        <!-- Amount yearly-->
                        <td >
                            <input class="form-control tabe-input text-end radius-none margin-65" type="number" [value]="value.amountYearly"  (keyup)="value.calculationBasis === 'fixed' || value.calculationBasis === 'percentage' ? calculateFixedPercentAmount(i, $event, j) : calculateFixedAmount(i, $event, j)">
                        </td>
                    </tr>
                </tbody>
                <tr class="comp-background">
                    <td class="">Cost To Company</td>
                    <td></td>
                    <td class="text-end  pe-4">{{compensationForm.controls['totalCalculatedMonthly'].value}}</td>
                    <td class="text-end  pe-4">{{compensationForm.controls['totalCalculatedYearly'].value}}</td>
                </tr>
                <!-- SK18JUN24 total deduction and net pay details -->
                <tr class="comp-background">
                    <td class="">Total Deductions(Deductions + Benefits)</td>
                    <td></td>
                    <td class="text-end  pe-4">{{compensationForm.controls['totalDeductionsMonthly'].value}}</td>
                    <td class="text-end  pe-4">{{compensationForm.controls['totalDeductionsYearly'].value}}</td>
                </tr>
                <tr class="comp-background">
                    <td class="">Net Pay</td>
                    <td></td>
                    <td class="text-end  pe-4">{{compensationForm.controls['totalNetPayMonthly'].value}}</td>
                    <td class="text-end  pe-4">{{compensationForm.controls['totalNetPayYearly'].value}}</td>
                </tr>
            </table>
            <div class="comp-background mt-4 ps-4 pt-4 pb-4">Over Time Calculation</div>
            <div class="flex flex-row ps-4 pe-4 mt-4 justify-content-between">
                <div class="w-50"> Calculation type to be included with Basic Pay </div>
                <div class="w-50 text-end">
                    <label *ngFor="let allowance of allowanceList" class="cursor-pointer ms-3">
                        <input type="radio" name="overTimeCalculationComps" formControlName="overTimeCalculationComps" [value]="allowance.componentName" (change)="overTimeAmount()" /> 
                        {{ allowance.componentName }}
                    </label>
                </div>
            </div>
            <div class="flex flex-row ps-4 pe-4 mt-3 justify-content-between">
                <div class="w-50">Number of regular working days in a month</div>
                <div class="w-50">
                    <input class="form-control tabe-input text-end radius-none margin-65" type="number" formControlName="overTimeCalcDays" (keyup)="calculateOT($event, 'overTimeCalcDays')">
                </div>
            </div>
            <div class="flex flex-row ps-4 pe-4 mt-3 justify-content-between">
                <div class="w-50">Number of regular working hours for this employee</div>
                <div class="w-50">
                    <input class="form-control tabe-input text-end radius-none margin-65" type="number"  formControlName="overTimeCalcHours" (keyup)="calculateOT($event, 'overTimeCalcHours')">
                </div>
            </div>
            <div class="flex flex-row ps-4 pe-4 mt-3 justify-content-between">
                <div class="w-50">Calculated OT amount/hour</div>
                <div class="w-50">
                    <input class="form-control tabe-input text-end radius-none margin-65" type="number"  formControlName="overTimeCalcAmount" (keyup)="calculateOT($event, 'overTimeCalcAmount')">
                </div>
            </div>
            <div *ngIf="isViewOn" class="w-100  mt-3  d-flex justify-content-end">
                <app-fusion-button buttonValue="Cancel" buttonType="text-only" (buttonClickEmit)="addNewRecord = false; editRecord = false; cancelAccordion(i)"></app-fusion-button>
                <app-fusion-button buttonValue="Save" [buttonDisable]="compensationForm.invalid" (buttonClickEmit)="saveCompensation()"></app-fusion-button>
            </div>
        </form>
    </div>
</div>
